import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'HighlightSearch'
})

export class HighlightSearch implements PipeTransform {

    transform(value: any, args: any): any {
        if (!args && value == null) {return value;}
        var tempString = value.split(/\s+/);
        var argTemp = args.replaceAll("\"","");
    	var temp = argTemp.split(/\s+/);
        temp.forEach((data,index)=>{
            var name = Object.keys(tempString).find(key => tempString[key].toLowerCase() === data.toLowerCase());
            if(name){
                tempString[name] = "<span class='highlight'>"+tempString[name]+"</span>";
                //console.log(tempString[name]);
            }
        });
        /*var count = 0;
    	temp.forEach((data, index)=>{
            var check = '<span class="highlight"></span>';
	        var re = new RegExp(data, 'gi'); //'gi' for case insensitive and 'g' for case sensitive.
	        var checkMatch = tempString.match(re);
            if(checkMatch != null){
                count++;
            }
            if(count < 2){
                var res = tempString.match(re);
                tempString = tempString.replace(re, function(str) {
                return "<span class='highlight'>" + str + "</span>"
                });
            }
    	});
        */
	    return tempString.join(' ');
    }
}